import { Map, Radio } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../../../components/tailwind/card";
import { Progress } from "../../../../../components/tailwind/progress";
import { workflowTheme } from "../../../utils/workflowBuilderTheme";

export function WorkflowAnalyticsHeatmap({ heatMapRows, liveSessionCount }) {
  const maxLive = Math.max(1, ...heatMapRows.map((row) => row.liveCount), liveSessionCount);
  const hasLiveNodes = heatMapRows.some((row) => row.liveCount > 0);

  return (
    <Card className={`h-full shadow-sm ${workflowTheme.card}`}>
      <CardHeader className="p-4 md:p-5 pb-2 space-y-1">
        <CardTitle className={`flex items-center gap-2 text-sm ${workflowTheme.textPrimary}`}>
          <Map className="h-4 w-4 text-purple-600 dark:text-purple-400 shrink-0" />
          Live occupancy
        </CardTitle>
        <p className={`text-xs font-normal ${workflowTheme.textSecondary}`}>
          {liveSessionCount} live session{liveSessionCount === 1 ? "" : "s"} right now
        </p>
      </CardHeader>
      <CardContent className="p-4 md:p-5 pt-2">
        {!hasLiveNodes ? (
          <p className={`text-sm py-2 ${workflowTheme.textMuted}`}>
            No users currently waiting on a node.
          </p>
        ) : (
          <div className="space-y-3">
            {heatMapRows
              .filter((row) => row.liveCount > 0)
              .map((item) => {
                const value = Math.round((item.liveCount / maxLive) * 100);
                return (
                  <div key={item.nodeId} className="space-y-1.5">
                    <div className="flex items-center justify-between gap-2">
                      <div className="flex items-center gap-2 min-w-0">
                        <Radio className="h-3.5 w-3.5 text-purple-600 dark:text-purple-400 shrink-0" />
                        <span className={`text-sm font-medium truncate ${workflowTheme.textPrimary}`}>
                          {item.label}
                        </span>
                      </div>
                      <span className={`text-sm font-bold tabular-nums ${workflowTheme.textPrimary}`}>
                        {item.liveCount}
                      </span>
                    </div>
                    <Progress
                      value={value}
                      className="h-1.5 bg-gray-100 dark:bg-slate-800"
                      indicatorClassName="bg-purple-500 dark:bg-purple-400"
                    />
                  </div>
                );
              })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
